import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_unigr-training/artifacts/wmq9fns7_Arquivos%20Logos_sem%20fundo-07%20%281%29.png";

export default function Logo({ size = 40, withText = true, className = "" }) {
  // height-driven layout: the official logo already contains the word + tagline
  const h = withText ? size + 8 : size;
  return (
    <div className={"flex items-center " + className} data-testid="unigr-logo">
      <img
        src={LOGO_URL}
        alt="UNIGR — conhecimento que transforma"
        style={{ height: h, width: "auto", maxWidth: "100%" }}
        draggable={false}
      />
    </div>
  );
}
